import { Carousel } from '@mantine/carousel';
import { ImageRatio } from '../Shares/ImageRatio';
export const BattlesBannerSlide: React.FC = () => {
  return <Carousel.Slide>
      <ImageRatio ratio={397 / 153} src="/assets/casino/banner-mobile.png" alt="casino-banner-slider" hiddenFrom="sm" />
      <ImageRatio ratio={1320 / 295} src="/assets/casino/casino-banner.png" alt="casino-banner-slider" visibleFrom="sm" />
    </Carousel.Slide>;
};